/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { createObservableDataAction, IAction, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { IDataServiceRequest, retailAction } from '@msdyn365-commerce/retail-proxy/dist';
import { createSearchOrgUnitLocationsInput } from '@msdyn365-commerce/retail-proxy/dist/DataActions/OrgUnitsDataActions.g';
import { ProductSearchResult, QueryResultSettings } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';


export const buildQueryResultSettings = (inputData: ICreateActionContext<IGeneric<IAny>, IGeneric<IAny>>): QueryResultSettings => {
    try {
        // not using this data-action for now, so overriding Top value to 4.
        // incase original functionality is required please remove this file.
        return { Paging: { Top: 4, Skip: 0 } };
    } catch {
        return {};
    }
};


/**
 * Search Org Unit Locations action createInput method.
 * @param inputData
 */
export function createSearchOrgUnitLocationsInputFunc(inputData: ICreateActionContext<IGeneric<IAny>, IGeneric<IAny>>): IDataServiceRequest {
    return createSearchOrgUnitLocationsInput(buildQueryResultSettings(inputData), {});
}

export const retailActionDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/search-org-unit-locations',
    action: <IAction<ProductSearchResult[]>>retailAction,
    input: createSearchOrgUnitLocationsInputFunc
});

export default retailActionDataAction;

